import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface Subscription {
  status?: 'trialing' | 'active' | 'canceled' | 'past_due' | 'unpaid';
  cancel_at_period_end?: boolean;
  current_period_end?: Date;
}

interface SubscriptionStatusMessageProps {
  effectiveStatus: string;
  subscription: Subscription;
  formatTrialDate: (dateInput?: string | Date | { toDate: () => Date }) => string;
}

const SubscriptionStatusMessage: React.FC<SubscriptionStatusMessageProps> = ({
  effectiveStatus,
  subscription,
  formatTrialDate,
}) => {
  const theme = useTheme();

  switch (effectiveStatus) {
    case 'trialing':
      return (
        <Typography variant="body2" sx={{ fontWeight: 'bold', color: theme.palette.warning.main }}>
          Trial ends on {formatTrialDate(subscription?.current_period_end)}
        </Typography>
      );
    case 'active':
      return (
        <Typography variant="body2">
          Your subscription is active. Renews on{' '}
          <strong>{formatTrialDate(subscription?.current_period_end)}</strong>.
        </Typography>
      );
    case 'expired':
      return (
        <Typography
          variant="body2"
          sx={{
            fontWeight: 'bold',
            color: theme.palette.text.error,
          }}
        >
          Plan expired on {formatTrialDate(subscription?.current_period_end)}
        </Typography>
      );
    default:
      return <Typography variant="body2">Your plan will not renew.</Typography>;
  }
};

export default SubscriptionStatusMessage;
